import router from "@/router";
import store from "@/store";
const CONTROLLEER_URL = "api/v1/";
const controller_fun = {
  formatUrl: url => {
    return `${CONTROLLEER_URL}${url}`;
  },
  log: response => {
    if (!store.getters.isDebug) {
      // eslint-disable-next-line
      console.dir({
        url: response.config.url,
        status: response.status,
        data: response.data
      });
    }
  },
  data: response => {
    return response.data;
  },
  success: data => {
    return "SUCCESS" === data.status;
  },
  checkResult: data => {
    switch (data.status) {
      /**需要登录 */
      case "ACCOUNT_OFFLINE":
        router.push({
          path: "/login"
        });
        break;
      /**需要实名认证 */
      case "ACCOUNT_REAL_CHECK":
        router.push({
          path: "/realName"
        });
        break;
      /**信息不完全，需要补充 */
      case "ACCOUNT_NEED_INFO":
        router.push({
          path: "/complete/info"
        });
        break;
      default:
        /**nothing */
        break;
    }
  },
  /**公共静态资源url */
  formatStaticResourceUrl: url => {
    return `${process.env.VUE_APP_WEB_URL}static/file/${url}`;
  }
};
export default controller_fun;
